module.exports = __webpack_public_path__ + "static/media/img-home-overview-userGuide.ddcb1826.jpg";